<script>
import moment from 'moment';
import Layout from "../../layouts/main";
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';
import appConfig from "@/app.config";

import SaleService from '@/services/sale'

moment.locale('pt-BR');

export default {
  page: {
    title: "Pedidos em Orçamentos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  data() {
    return {
      title: "Pedidos em Orçamentos",
      loading: false,
      sales: [],
      saleSelected: '',
      searchParams: {
        customer: '',
        startDate: '',
        endDate: '',
      },
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 0,
      startIndex: 0,
      endIndex: 0,

      totalSales: 0,

      fields: [
        { key: 'companyName', sortable: true, label: 'Filial' },
        { key: 'code', sortable: true, label: 'Nº Pedido' },
        { key: 'customerName', sortable: true, label: 'Cliente' },
        { key: 'statusDescription', sortable: true, label: 'Status' },
        { key: 'sellerName', sortable: true, label: 'Vendedor' },
        { key: 'date', sortable: true, label: 'Emissão', formatter: (value) => {
            return moment(value).format('DD/MM/YYYY HH:mm:ss');
          }
        },
        { key: 'totalValue', sortable: true, label: 'R$ Total', class: 'nowrap-col', formatter: (value) => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        { key: 'actions', label: 'Ações', class: 'nowrap-col' }
      ],

      itemsFields: [
        { key: 'product.code', label: 'Código' },
        { key: 'product.description', label: 'Produto' },
        { key: 'quantity', label: 'Qtde.' },
        { key: 'price', label: 'Valor Unitário', formatter: (value, key, item) => {
          return (item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'total', label: 'Valor Total', formatter: (value, key, item) => {
          return (item.quantity * item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } }
      ]
    };
  },
  mounted() {
    const now = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);

    this.searchParams.startDate = startDate;
    this.searchParams.endDate = now;

    this.search();
  },
  methods: {
    search() {
      this.loadSales();
    },
    loadSales(page = 1, showLoading = true) {
      if (showLoading) {
        this.loading = true;
      }

      if (!this.searchParams.startDate) {
        if (!this.searchParams.endDate) {
          this.searchParams.endDate = new Date();
        }
        
        const startDate = new Date(this.searchParams.endDate);
        startDate.setDate(startDate.getDate() - 7);
        this.searchParams.startDate = startDate;
      }

      if (!this.searchParams.endDate) {
        this.searchParams.endDate = new Date();
      }

      SaleService.getSales(this.searchParams, page)
        .then(res => {
          this.loading = false;

          this.sales = res.data.sales;
          this.count = res.data.count;
          this.currentCount = res.data.currentCount;
          this.currentPage = res.data.currentPage;
          this.totalPages = res.data.totalPages;
          this.perPage = res.data.perPage;
          this.startIndex = res.data.startIndex;
          this.endIndex = res.data.endIndex;

          this.totalSales = res.data.totalSales;
        })
      .catch(() => {
        this.loading = false;
      })
    },
    onPageChange() {
      window.scrollTo(0,0);
      this.loadSales(this.currentPage);
    },
    openOrder(sale) {
      this.$store.dispatch('OPEN_ORDER', {
        cartId: sale._id,
        customerId: sale.customer._id,
        companyId: sale.company._id,
      })

      this.$router.push({ name: "products" })
    },
    confirmRemoveSale(data) {
      this.saleSelected = data._id;
      this.$bvModal.show('modal-confirm');
    },
    removeSale() {
      this.$bvModal.hide('modal-confirm');

      SaleService.removeSale(this.saleSelected).then(() => {
        this.loadSales(1, false);
      }).catch(() => {

      })
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="search" class="align-items-center">
              <div class="row">
                <div class="col-lg-6 col-sm-12">
                  <div class="form-group">
                    <label>Cliente</label>
                    <input type="text" v-model="searchParams.customer" class="form-control" placeholder="Informe o nome do cliente" />
                  </div>

                  <div class="row">
                    <div class="col-6">
                      <div class="form-group mb-3">
                        <label>Período de</label>
                        <date-picker v-model="searchParams.startDate" :first-day-of-week="1" format="DD/MM/YYYY" lang="pt-br"></date-picker>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-group mb-3">
                        <label>até</label>
                        <date-picker v-model="searchParams.endDate" :first-day-of-week="1" format="DD/MM/YYYY" lang="pt-br"></date-picker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="button-search">
                <b-button type="submit" variant="primary" v-if="!loading">Filtrar</b-button>
                <a href="javascript:void(0);" class="text-primary" v-if="loading">
                  <b-spinner class="ml-2" variant="primary" role="status"></b-spinner>
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="sales"
                :fields="fields"
                responsive="sm"
                head-variant="light"
              >
                <template v-slot:cell(statusDescription)="row">
                  <span
                    class="badge badge-pill badge-soft-primary font-size-12"
                  >{{row.item.statusDescription}}</span>
                </template>
                
                <template v-slot:cell(actions)="row">
                  <a href="javascript:void(0);" class="action-icon text-success mr-3" @click="row.toggleDetails">
                    <i class="mdi mdi-eye font-size-18"></i>
                  </a>
                  <a href="javascript:void(0);" class="action-icon text-primary mr-3" @click="openOrder(row.item)">
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>
                  <a href="javascript:void(0);" class="action-icon text-danger" @click="confirmRemoveSale(row.item)">
                    <i class="mdi mdi-trash-can font-size-18"></i>
                  </a>
                </template>

                <template v-slot:row-details="row">
                  <b-table
                    bordered
                    small
                    :items="row.item.items"
                    :fields="itemsFields"
                    responsive="sm"
                  >
                  </b-table>
                </template>

                <template slot="bottom-row">
                  <td colspan="5" class="border-0 text-right"></td>
                  <td class="border-0 text-left">
                    <strong>Valor Total:</strong>
                  </td>
                  <td class="border-0 text-left text-truncate">
                    <h4 class="m-0">R$ {{totalSales | currency}}</h4>
                  </td>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{count}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="count"
                :per-page="perPage"
                @input="onPageChange"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-confirm"
      title="Confirmação"
      title-class="font-18"
      centered
    >
      <p>Tem certeza que deseja excluir esse orçamento?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-confirm')" class="mr-3">Voltar</b-btn>
        <b-btn variant="primary" @click="removeSale">Excluir Orçamento</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>


<style lang="scss">
  .button-search {
    display: flex;
    align-items: center;
  }

  .nowrap-col {
    white-space: nowrap;
  }
</style>